export default function(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-polygon/src/area.js
// module id = KJPC
// module chunks = 0